import { useEffect } from 'react';
import { useAppDispatch } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { useEffectOnce } from '@/hooks/useEffectOnce';

// Dispatched by an experiment's custom JS once it has put its overrides on `window.config`.
const CUSTOM_JAVASCRIPT_LOADED = 'customJavaScriptLoaded';

const useConfigFromExperiment = () => {
  const dispatch = useAppDispatch();

  const onCustomJavaScriptLoaded = (source: string) => {
    console.log(`Custom JavaScript loaded from: ${source}`);
    dispatch(ConfigSlice.actions.updateConfigWithOptimizelyValues());
  };

  useEffect(() => {
    // One named handler for both calls — passing a fresh arrow to each meant the listener was
    // never actually removed and piled up on every remount.
    const onEvent = () => onCustomJavaScriptLoaded('event listener');
    document.addEventListener(CUSTOM_JAVASCRIPT_LOADED, onEvent);
    return () => {
      document.removeEventListener(CUSTOM_JAVASCRIPT_LOADED, onEvent);
    };
  }, []);

  // Latched: StrictMode double-invokes mount effects in dev, so a plain effect merged the config
  // twice per page load.
  useEffectOnce(() => {
    onCustomJavaScriptLoaded('useEffect on mount');
  });
};

export default useConfigFromExperiment;
